export const emailPattern = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
export const phoneNumberPattern = /^[+]*[(]{0,1}[0-9]{1,4}[)]{0,1}[-\s./0-9]*$/
export const mobileNumberPattern = /^[0-9]{10}$/

// Phone number formatting templates
const PHONE_FORMAT_PARTIAL = '($1) $2'
const PHONE_FORMAT_FULL = '($1) $2-$3'

export function formatPhoneNumber(phoneNumber) {
  const pNumber = phoneNumber?.replace(/\D/g, '') || ''

  if (pNumber.length <= 3) {
    return pNumber
  } else if (pNumber.length <= 6) {
    return pNumber.replace(/(\d{3})(\d{1,3})/, PHONE_FORMAT_PARTIAL)
  } else {
    return pNumber.replace(/(\d{3})(\d{3})(\d{1,4})/, PHONE_FORMAT_FULL)
  }
}

export function removePhoneNumberFormat(phoneNumber) {
  const pNumber = phoneNumber?.replace('+1', '').replace(/\D/g, '')
  return pNumber
}

export const validateEmail = val => {
  return emailPattern.test(val)
}

export const validatePhone = val => {
  const pNumber = removePhoneNumberFormat(val)
  return /^[0-9]{10}$/.test(pNumber)
}
